import { render, staticRenderFns } from "./ServicePriceList.vue?vue&type=template&id=0a5a1e07&scoped=true&"
import script from "./ServicePriceList.vue?vue&type=script&lang=js&"
export * from "./ServicePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a1e07",
  null
  
)

export default component.exports